module.exports = __webpack_public_path__ + "img/cloud_dark.10f5fbfc.png";